export const CADASTRO_PEDIDO_FIGURACAO = 'CADASTRO_PEDIDO_FIGURACAO';

export const CADASTRO_FIGURANTE = 'CADASTRO_FIGURANTE';
export const CADASTRO_FIGURANTE_VEICULO = 'CADASTRO_FIGURANTE_VEICULO';
export const CADASTRO_FIGURANTE_ANIMAL = 'CADASTRO_FIGURANTE_ANIMAL';
export const CADASTRO_FIGURANTE_FISCAL = 'CADASTRO_FIGURANTE_FISCAL';
export const CADASTRO_FIGURANTE_ALVARA = 'CADASTRO_FIGURANTE_ALVARA';
export const CHECKIN_FIGURANTE = 'CHECKIN_FIGURANTE';
export const ESCALACAO_FIGURANTE = 'ESCALACAO_FIGURANTE';
export const CADASTRO_CARTA_FATURA = 'CADASTRO_CARTA_FATURA';
export const BUSCA_CARTA_FATURA = 'BUSCA_CARTA_FATURA';
export const GESTAO_CONTEUDO = 'GESTAO_CONTEUDO';
export const BUSCA_GERAL = 'BUSCA_GERAL';
export const BUSCA_FIGURANTE = 'BUSCA_FIGURANTE';
export const BUSCA_FISCAL = 'BUSCA_FISCAL';
export const BUSCA_PEDIDO_FIGURACAO = 'BUSCA_PEDIDO_FIGURACAO';
export const BUSCA_ESCALACAO = 'BUSCA_ESCALACAO';
export const SOLICITACAO_PEDIDO_FIGURACAO = 'SOLICITACAO_PEDIDO_FIGURACAO';
export const APROVACAO_PRODUTOR_EXECUTIVO = 'APROVACAO_PRODUTOR_EXECUTIVO';

export const RELATORIO_GERENCIAL = 'RELATORIO_GERENCIAL';
export const RELATORIO_ITEM_PEDIDO = 'RELATORIO_ITEM_PEDIDO';
export const RELATORIO_GERENCIAL_AGENCIA = 'RELATORIO_GERENCIAL_AGENCIA';
export const RELATORIO_VALORACAO = 'RELATORIO_VALORACAO';
export const RELATORIO_ESCALACAO_MENOR = 'RELATORIO_ESCALACAO_MENOR';
export const RELATORIO_ALVARA_MENOR = 'RELATORIO_ALVARA_MENOR';
export const RELATORIO_PORTARIA_SEGURANCA = 'RELATORIO_PORTARIA_SEGURANCA';
export const RELATORIO_SEGUROS = 'RELATORIO_SEGUROS';
export const RELATORIO_PEDIDOS_FIGURACAO = 'RELATORIO_PEDIDOS_FIGURACAO';
export const RELATORIO_FIGURANTES_BLOQUEADOS = 'RELATORIO_FIGURANTES_BLOQUEADOS';
export const RELATORIO_RESUMO_PEDIDO = 'RELATORIO_RESUMO_PEDIDO';
export const SEGURANCA_TRANSPORTE = 'SEGURANCA_TRANSPORTE';
